import React from 'react';
import { FlagIcon } from './UI';
export const TopBar = () => {
  return <div className="bg-base-black border-b border-acid-green-border py-2 px-4 text-xs font-barlow tracking-wider flex flex-col sm:flex-row justify-between items-center gap-1 sm:gap-0 z-50 relative" data-id="element-1400">
      <div className="flex items-center text-acid-green" data-id="element-1401">
        <span className="w-2 h-2 rounded-full bg-acid-green animate-pulse mr-2" data-id="element-1402"></span>
        OPERATIONAL — UNITS DEPLOYING NOW
      </div>

      <div className="flex items-center space-x-4 text-text-dimmed hidden md:flex" data-id="element-1403">
        <span className="text-white" data-id="element-1404">
          FREE SHIPPING ON ALL ORDERS IN THE USA
        </span>
        <span data-id="element-1405">|</span>
        <span data-id="element-1406">BUILT BY OPERATORS. FOR OPERATORS.</span>
        <span data-id="element-1407">|</span>
        <span className="flex items-center gap-2" data-id="element-1408">
          <FlagIcon className="w-4 h-3" data-id="element-1409" /> AMERICAN MADE
        </span>
      </div>

      <div className="flex items-center gap-2 text-text-dimmed sm:hidden" data-id="element-1410">
        <span className="text-white" data-id="element-1411">
          FREE SHIPPING ON ALL ORDERS IN THE USA
        </span>
      </div>
    </div>;
};